interface IOPtions {
  interval: number;
  maxAttempts: number;
  rejectOnTimeout: boolean;
}

const DEFAULT_POLL_OPTIONS: IOPtions = {
  interval: 100,
  maxAttempts: 50,
  rejectOnTimeout: true,
};

const executePoll = async (condition: () => boolean, defaultOptions: Partial<IOPtions> = {}): Promise<boolean> => {
  let attempts = 0;
  let timerId: ReturnType<typeof setTimeout>;

  const optionsOverride = {
    ...DEFAULT_POLL_OPTIONS,
    ...defaultOptions,
  };

  const checkCondition = (resolve: (reason?: any) => void, reject: (reason: unknown) => void): void => {
    if (attempts >= optionsOverride.maxAttempts) {
      clearTimeout(timerId);
      if (optionsOverride.rejectOnTimeout) {
        return reject(false);
      }
      return resolve(false);
    }

    if (!condition()) {
      attempts++;
      timerId = setTimeout(checkCondition, optionsOverride.interval, resolve, reject);
      return;
    }

    clearTimeout(timerId);
    return resolve(true);
  };

  return await new Promise(checkCondition);
};

export default executePoll;
